"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var forms_1 = require("@angular/forms");
var lang_1 = require("../util/lang");
exports.maxDate = function (maxDate) {
  if (!lang_1.isDate(maxDate) && !(maxDate instanceof Function)) {
    throw Error('maxDate value must be or return a formatted date');
  }
  return function (control) {
    if (lang_1.isPresent(forms_1.Validators.required(control))) return null;
    var d = new Date(control.value);
    if (!lang_1.isDate(d)) return {
      maxDate: true
    };
    if (maxDate instanceof Function) maxDate = maxDate();
    return d <= new Date(maxDate) ? null : {
      maxDate: true
    };
  };
};
